import { useEffect } from 'react';

const useBeforeUnload = (shouldPrompt) => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldPrompt()) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldPrompt]);
};

export default useBeforeUnload;
